import api from "./api";

// Fetch all contact support messages
export const fetchAllContactSupportMessages = async (filters = {}) => {
  try {
    const response = await api.get('/contact-support-management/support/list-all', { params: filters });
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching contact support messages:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to fetch contact support messages" };
  }
};

// Update a specific contact support message
export const updateContactSupportMessage = async (messageId, updateData) => {
  try {
    const response = await api.put(`/contact-support-management/support/${messageId}`, updateData);
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating contact support message:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to update contact support message" };
  }
};
